import React from 'react'

export const IconArrowDown = ({ mode = '' }) => {
  return (
    <svg
      style={{
        transition: '.15s',
        transform: `rotate(${mode === 'low' ? '180deg' : '0deg'})`,
      }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 14.5856L19.2929 7.29274L20.7071 8.70696L12 17.4141L3.2929 8.70696L4.70711 7.29274L12 14.5856Z"
        fill="#878696"
      />
    </svg>
  )
}
